module.exports = __webpack_public_path__ + "static/Updated_3M_2026_Financial_Pages_HSE_Investment_sarl_002-bfbbdc4da80e1d192ecd06632fb96853.pdf";